let websock = null
let messageCallback = null
let errorCallback = null

// 接收ws后端返回的数据
function websocketonmessage(e) {
	console.log('ws收到消息' + e.currentTarget.url);
	messageCallback(e.currentTarget.url)
}

/**
 * 发起websocket连接
 * @param {Object} agentData 需要向后台传递的参数数据
 */
function websocketSend(agentData) {
	// 加延迟是为了尽量让ws连接状态变为OPEN   
	setTimeout(() => {
		// 添加状态判断，当为OPEN时，发送消息
		if (websock.readyState === websock.OPEN) { // websock.OPEN = 1 
			// 发给后端的数据需要字符串化
			websock.send(JSON.stringify(agentData))
		}
		if (websock.readyState === websock.CLOSED) { // websock.CLOSED = 3 
			console.log('websock.readyState=3')
			console.log('ws连接异常，请稍候重试')
			errorCallback()
		}
	}, 500)

	setInterval(() => {
		if (websock.readyState === websock.OPEN) { // websock.OPEN = 1 
			// 发给后端的数据需要字符串化
			console.log('发送心跳');
			websock.send(JSON.stringify({}))
		} else if (websock.readyState === websock.CLOSED) { // websock.CLOSED = 3 
			console.log('websock.readyState=3')
			console.log('ws连接异常，请稍候重试4')
		}
	}, 1000 * 60);
}

// 关闭ws连接
function websocketclose(e) {
	if (e && e.code !== 1000) {
		console.log('ws连接异常，请稍候重试3')
		errorCallback()
	}
}
// 建立ws连接
function websocketOpen() {
	console.log('ws连接成功')
}

// 初始化weosocket
function initWebSocket(requstWsUrl) {
	if (typeof (WebSocket) === 'undefined') {
		console.log('您的浏览器不支持WebSocket，无法获取数据')
		return false
	}

	// ws请求完整地址
	//const requstWsUrl = wsUrl
	websock = new WebSocket(requstWsUrl)

	websock.onmessage = function (e) {
		websocketonmessage(e)
	}
	websock.onopen = function () {
		websocketOpen()
	}
	websock.onerror = function () {
		console.log('ws连接异常，请稍候重试1')
		errorCallback();
	}
	websock.onclose = function (e) {
		console.log('ws连接关闭，请稍候重试2')
		websocketclose(e);
		setTimeout(() => {
			initWebSocket(requstWsUrl);
		}, 1000 * 30);

	}
}

/**
 * 发起websocket请求函数
 * @param {string} url ws连接地址
 * @param {Object} agentData 传给后台的参数
 * @param {function} successCallback 接收到ws数据，对数据进行处理的回调函数
 * @param {function} errCallback ws连接错误的回调函数
 */
export function sendWebsocket(url, agentData, successCallback, errCallback) {
	initWebSocket(url)
	messageCallback = successCallback
	errorCallback = errCallback
	websocketSend(agentData)
}

/**
 * 关闭websocket函数
 */
export function closeWebsocket() {
	if (websock) {
		websock.close() // 关闭websocket
		websock.onclose() // 关闭websocket
	}
}
